import e, { useMemo as t } from "react";
var n = function (n) {
  var r = n.options,
    a = t(function () {
      return r.map(function (t, n) {
        return e.createElement("option", {
          key: t.value,
          value: t.value
        }, t.label);
      });
    }, [r]);
  return e.createElement(e.Fragment, null, a);
};
export { n as OptionsRenderer };